module.exports = "\r\n  <div *ngFor=\"let message of messages | async | reverse\">\r\n    <div class=\"alert alert-primary\" role=\"alert\">\r\n\r\n\r\n      {{message.content}}\r\n      <button class=\"btn btn-primary\" (click)=\"dismiss(message.$key)\"></button>\r\n    </div>\r\n\r\n  </div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/toast-messages/toast-messages.component.html
// module id = ./src/app/toast-messages/toast-messages.component.html
// module chunks = main